import { useQuery } from '@tanstack/react-query'

import { foodStockInstance } from '@/modules/foodStock'

export function getListPatientsFoodStockQuery(patientId?: string) {
  const baseKey = 'patientFoodStock'
  return patientId ? [baseKey, patientId] : [baseKey]
}

export function useListPatientFoodStockQuery({
  patientId,
  enabled
}: {
  patientId: string
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getListPatientsFoodStockQuery(patientId),
    queryFn: async () =>
      await foodStockInstance.listPatientFoodStockCase(patientId),
    enabled
  })
}
